import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import load from './spinner.gif'
function Load() {
  return (
<div class="spinner-border text-primary" role="status">
  <span class="sr-only">Loading...</span>
</div>
  );
}

export default Load;